import React, { Component, Suspense } from 'react';
import { HashRouter, Route, Routes, Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchAgentInfo } from './store'; // Import action
import WebSocketHandler from './websocket';
import { Toaster } from 'src/components/ui/toaster';
import './scss/style.scss';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const ModernLayout = React.lazy(() => import('./layout/ModernLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const RegisterConfirm = React.lazy(() => import('./views/pages/register/RegisterConfirm'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));
const AccountFrozen = React.lazy(() => import('./views/pages/account_frozen/AccountFrozen'))
const ForgotPassword = React.lazy(() => import('./views/pages/forgot_password/ForgotPassword'))
const DelegateEntryPage = React.lazy(() => import('./views/pages/delegate_entry/DelegateEntryPage'))
const HelpStandalonePage = React.lazy(() => import('./views/help/HelpStandalonePage'))

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agentInfoLoaded: false, // agentInfo 로딩 상태 추적
    };
  }

  componentDidUpdate(prevProps) {
    const { token, agentInfo, delegateSession, fetchAgentInfo } = this.props;
    // Skip auth refresh if in delegate session
    if (delegateSession?.isActive) return;
    if (token && !agentInfo && prevProps.token !== token && !this.state.agentInfoLoaded) {
      fetchAgentInfo();
    }
    if (agentInfo && !this.state.agentInfoLoaded) {
      this.setState({ agentInfoLoaded: true });
    }
  }

  render() {
    const { token, delegateSession, rehydrated } = this.props;
    const { agentInfoLoaded } = this.state;
    const isAuthenticated = !!token || delegateSession?.isActive;

    if (!rehydrated) {
      return loading;
    }

    return (
      <HashRouter>
        <Suspense fallback={loading}>
          <WebSocketHandler/>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Navigate to="/register" replace />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register/confirm" element={<RegisterConfirm />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/404" element={<Page404 />} />
            <Route path="/500" element={<Page500 />} />
            <Route path="/account-frozen" element={<AccountFrozen />} />
            <Route path="/delegate-entry" element={<DelegateEntryPage />} />
            {/* Standalone, publicly-accessible Help page — intentionally
                outside the auth guard below so opening Help in a new tab
                works whether or not the reader is signed in. */}
            <Route path="/help" element={<HelpStandalonePage />} />
            <Route
              path="*"
              element={isAuthenticated ? <ModernLayout /> : <Navigate to="/login" replace />}
            />
          </Routes>
        </Suspense>
        <Toaster />
      </HashRouter>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.auth.token,
  agentInfo: state.auth.agentInfo,
  delegateSession: state.delegateSession,
  rehydrated: state._persist?.rehydrated ?? false,
});

const mapDispatchToProps = { fetchAgentInfo };

export default connect(mapStateToProps, mapDispatchToProps)(App);